
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { UserPageColumnSettings } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/UserPageColumnSettings";
import { TableColSettingsDispatcher } from "./Variable";

export interface TableColSettingsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: UserPageColumnSettings;
}

export class TableColSettingsStatic extends BaseStore<TableColSettingsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(TableColSettingsDispatcher, (actionData) => this.onTableColSettingsStoreResponse(actionData));
    }

    public getLastResult(): TableColSettingsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): TableColSettingsStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onTableColSettingsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
